import React from "react";
import NavbarSearch from "./NavbarSearch";

function DesktopNavbarNav({
  navigate,
  t,
  isLoggedIn,
  isAdmin,
  currentUserId,
  searchContainerRef,
  query,
  handleSearchChange,
  isSearching,
  showResults,
  searchResults,
  currentLang,
}) {
  return (
    <ul className="flex items-center gap-4">
      <li>
        <button
          className="text-[#AAA] font-medium hover:bg-[#575757] px-4 py-2 rounded w-full text-left"
          onClick={() => navigate("/catalog")}
        >
          {t("catalog")}
        </button>
      </li>

      {isLoggedIn && isAdmin && (
        <li>
          <button
            className="text-[#AAA] font-medium hover:bg-[#575757] px-4 py-2 rounded w-full text-left"
            onClick={() => navigate(`/admin/${currentUserId}`)}
          >
            {t("admin")}
          </button>
        </li>
      )}
      {isLoggedIn && isAdmin && (
        <li>
          <button
            className="text-[#AAA] font-medium hover:bg-[#575757] px-4 py-2 rounded w-full text-left"
            onClick={() => navigate(`/budget/${currentUserId}`)}
          >
            {t("budget")}
          </button>
        </li>
      )}

      {/* Поиск */}
      <NavbarSearch
        variant="desktop"
        navigate={navigate}
        t={t}
        searchContainerRef={searchContainerRef}
        query={query}
        handleSearchChange={handleSearchChange}
        isSearching={isSearching}
        showResults={showResults}
        searchResults={searchResults}
        currentLang={currentLang}
      />
    </ul>
  );
}

export default DesktopNavbarNav;
